import cn from 'classnames'
import React from 'react'

export const Content = ({ className, ...props }) => (
    <div className={cn('md:flex md:flex-row relative', className)} {...props} />
)

export default Content
